import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { COLOR_GREY_5 } from "shared/theme/colors";

export const StyledContainer = styled(Box)`
  position: relative;
  margin-botton: 1.5rem;
  height: 100%;
  width: 692px;
  padding: 1.5rem;
  border: 1px solid ${COLOR_GREY_5};
  border-radius: 16px;
`;
